module.exports = __webpack_public_path__ + "media/images/lps-buy_investment-5ee3131e.png";